import { forwardRef } from 'react';
import { FormBuilder } from '@/formbuilder/FormBuilder.page';
import type { FunctionComponent } from 'react';
import type { FormBuilderProps } from '@/formbuilder/FormBuilder.page';

interface SimpleSaveFormBuilderProps extends FormBuilderProps {
  /** the function that is called when the form is submitted */
  submitFn: (values: any) => void;
  extraClassNames?: string;
}

/**
 * SimpleSaveFormBuilder generates forms based on the provided form definition Array.
 * SimpleSaveFormBuilder is NOT TO BE USED for tools - use ToolFormBuilder for tools. SimpleSaveFormBuilder should
 * be used for forms that only display a save/cancel button, and do not need tool specific tracking.
 **/
// eslint-disable-next-line @typescript-eslint/no-restricted-types -- Legacy wrapper still exposes FunctionComponent.
export const SimpleSaveFormBuilder: FunctionComponent<SimpleSaveFormBuilderProps> = forwardRef(
  function SimpleSaveFormBuilder(props, ref) {
    return <FormBuilder {...props} ref={ref} saveAndCancel={true} extraClassNamesUnwrapped={props.extraClassNames} />;
  },
);
